import React from 'react';

const ContactoAgenciaHorizontal = (props) => {
  const agencia = props.datosAgencia.Agencia;

  return (
    <div className='panel panel-default custom bordeado '>
      <div className='panel-body'>
        <div className='texto-info-agencia'>
          <div className='row'>
            <div className='col-lg-3'>
              <div className='clearfix'>
                <div className='contenedor-centrado'>
                  <img
                    style={{ marginTop: '1.4em' }}
                    src={`https://mundigea.com.ar/tpl/img/usuarios/${
                      agencia.Id
                    }/logo1_img_250x100.jpg`}
                    height={55}
                    className='img-resposive'
                    alt={agencia.Nombre}
                  />
                </div>
              </div>
            </div>
            <div className='col-lg-9'>
              <h6>Contactate con nosotros</h6>
            </div>
            <div className='col-lg-3'>
              <div>
                <b>Direccion: </b>
                {' '}
                <span>
                  {' '}
                  {agencia.Direccion}
                </span>
              </div>
              <div>
                <b>Telefono: </b>
                {' '}
                <span>
                  {' '}
                  {agencia.Telefono}
                </span>
              </div>
              <div>
                <b>Email: </b>
                {' '}
                <span>
                  {' '}
                  {agencia.Email}
                </span>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='dato horarios'>
                <span>Econtranos en nuestras oficinas de:</span>
              </div>
              <p>
                <b>
                  {agencia.HorarioAtencion
                    ? agencia.HorarioAtencion
                    : 'No se pudo encontrar el horario de atencion.'}
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactoAgenciaHorizontal;
